export enum PayoutFrequencyType {
  MONTHLY = "MONTHLY",
  BIWEEKLY = "BIWEEKLY",
  WEEKLY = "WEEKLY",
}

export enum WeeklyAnchorStripe {
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
}

export enum BiweeklyPeriod {
  FIRST_AND_THIRD_WEEK = "FIRST_AND_THIRD_WEEK",
  SECOND_AND_FOURTH_WEEK = "SECOND_AND_FOURTH_WEEK",
}

export type PayoutFrequency = {
  type: PayoutFrequencyType
  dayCalendar?: number // 1-31, only for MONTHLY
  weeklyAnchorStripe?: WeeklyAnchorStripe // only for WEEKLY
  biweeklyPeriod?: BiweeklyPeriod // only for BIWEEKLY
}
